import { render, staticRenderFns } from "./IconSocial.vue?vue&type=template&id=7fcd0e56&"
import script from "./IconSocial.vue?vue&type=script&lang=js&"
export * from "./IconSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports